module.exports = __webpack_public_path__ + "img/vip.028af017.png";